<template>
  <section class="job-overview m-t-lg m-b-lg">
    <h2>
      <i class="far fa-truck"></i> Jobs
      <router-link
        v-if="$user.isEnabled && $user.isActivated"
        class="material-plus job-new"
        :to="{ name: 'jobs.create' }">
        +
      </router-link>
    </h2>

    <div class="ibox">
      <div class="ibox-content">
        <ul class="list-detail list-detail-job">
          <job-item
            v-for="job in jobs"
            :key="job.id"
            :job="job">
          </job-item>

          <li class="text-center text-muted" v-if="haveNoJobs">
            <strong>No jobs found.</strong>
          </li>
        </ul>
      </div>
      <div class="ibox-footer">
        <router-link :to="{ name: 'jobs.index'}">View All Jobs</router-link>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapActions } from 'vuex'
  import { map } from 'lodash'
  import { JobDecorator } from 'decorators'
  import JobItem from 'components/jobs/JobItem'

  export default {
    components: {
      JobItem
    },

    data () {
      return {
        jobs: []
      }
    },

    computed: {
      haveNoJobs () {
        return this.jobs.length === 0
      }
    },

    created () {
      this.getJobs({ status: 'all', commodity: 'all', page_size: 8 })
        .then((response) => {
          this.jobs = map(response.data.data, job => new JobDecorator(job))
        })
    },

    methods: mapActions('job', ['getJobs'])
  }
</script>



// WEBPACK FOOTER //
// JobList.vue?1350b22a